import React, { useContext, useState, useEffect } from 'react';

const SessionContext = React.createContext({
    loading: true,
    isDefault: true,
    organisationDetails: undefined
});

export const useSessionContext = (selector, customSetter = undefined) => {
  const store = useContext(SessionContext);
  if (!store) {
    throw new Error('Store not found');
  }

  const [ state, setState ] = useState(selector(store.get()));

  useEffect(() => {
    return store.subscribe(() => {
      setState(previousState => {
        return selector(store.get(), previousState);
      });
    });
  }, []);

  return [state, store.set];
}

export const checkUserAccess = (userType, roles, userDetails = {}) => {
  if (roles) {
    return (
      userDetails?.userType === userType && userDetails.roles.some(role => roles.includes(role))
    );
  } else {
    return userDetails?.userType === userType;
  }
};

export default SessionContext;